/**
 * @file Service for the drop zones
 * @author Heino Lenting
 */
import * as tslib_1 from "tslib";
import { EventEmitter } from '@angular/core';
import { DataSet } from '../core/helpers/data-set';
import * as moment from 'moment';
import { DomainService } from '../domain.service';
import { SortDescriptor } from '../core/helpers/sort-descriptor';
import { SortDirection } from '../core/helpers/sort-direction';
import { EventsService } from '../core/event.service';
import { AbstractBase } from '../core/helpers/abstract-base';
/**
 * Service to retrieve and execute the exectures
 */
var DropTargetsService = /** @class */ (function (_super) {
    tslib_1.__extends(DropTargetsService, _super);
    /**
     * Constructs a DropZones Service
     */
    function DropTargetsService(domainService, eventsService) {
        var _this = _super.call(this) || this;
        _this.domainService = domainService;
        _this.dropTargetsChanged = null;
        _this.dropTargetsChanged = eventsService.register('drop-targets-changed');
        return _this;
    }
    /**
     * Finds the resources that can comply for the work.
     * @param {Entity} work The work.
     * @returns {Observable<Resource[]>} An collection of resoures
     */
    DropTargetsService.prototype.complyResources = function (work) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var dataSet, result;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        dataSet = new DataSet(this.domainService);
                        dataSet.entityType = this.resourceType;
                        dataSet.sourceName = 'ComplyResources';
                        dataSet.sorting = [];
                        dataSet.queryOptions = {
                            parameters: {
                                work: work['Item_Oid'] ? work['Item_Oid'] : work['Oid'],
                                start: work['Start'],
                                finish: work['Finish']
                            }
                        };
                        // Clear the sorting and add sort descriptor
                        dataSet.sorting.length = 0;
                        dataSet.sorting.push(new SortDescriptor('Name', 'Name', SortDirection.Ascending, 0));
                        return [4 /*yield*/, dataSet.refresh()];
                    case 1:
                        result = _a.sent();
                        return [2 /*return*/, result.results];
                }
            });
        });
    };
    /**
     * Register the resources
     *
     * @param {DataSet} resources
     */
    DropTargetsService.prototype.registerResources = function (resources) {
        this.resources = resources;
    };
    /**
     * Register the grid collections
     *
     * @param {GridCollections} gridCollections
     */
    DropTargetsService.prototype.registerGridCollections = function (gridCollections) {
        this.gridCollections = gridCollections;
    };
    DropTargetsService.prototype.autoClearDropTargets = function () {
        var _this = this;
        this.autoHideTimer = window.setTimeout(function () {
            _this.clearDropTargets();
        }, 5000);
    };
    /**
     * Clear the drop targets
     */
    DropTargetsService.prototype.clearDropTargets = function () {
        // Clear the auto hide timer for the previous run (to prevent hiding again)
        clearTimeout(this.autoHideTimer);
        // Clear the drop zones (resources)
        if (this.resources && this.resources.items) {
            if (this.resources && this.resources.items) {
                this.resources.items.forEach(function (resource) {
                    resource['isDropZone'] = undefined;
                });
            }
        }
        // Clear the drop zones (timeslots)
        if (this.gridCollections) {
            this.gridCollections.forEach(function (gridCollection) {
                gridCollection.children.forEach(function (gridSegment) {
                    gridSegment.children.forEach(function (gridRow) {
                        gridRow.children.forEach(function (gridColumn) {
                            gridColumn.meta.isDropZone = undefined;
                        });
                    });
                });
            });
        }
        this.dropTargetsChanged.emit(false);
    };
    /**
     * Get drop targets resources comply and call next function
     * @param {ExecutorData} data
     */
    DropTargetsService.prototype.doComplyResourcesDropTargets = function (data, fn) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var resources_1, reason_1;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.complyResources(data.items[0])];
                    case 1:
                        resources_1 = _a.sent();
                        // agenda ondersteunt dit nog niet, zou dit wel moeten?
                        if (this.resources) {
                            this.resources.items.forEach(function (item) {
                                var resourceOid = item['Oid'];
                                item['isDropZone'] = resources_1.some(function (resource) { return resource['Oid'] === resourceOid; });
                            });
                            fn();
                        }
                        return [3 /*break*/, 3];
                    case 2:
                        reason_1 = _a.sent();
                        // TODO: Error handeling.
                        console.error(reason_1);
                        return [3 /*break*/, 3];
                    case 3:
                        this.autoClearDropTargets();
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
    * Get drop targets overlaps first dropitem
    *
    * @param {ExecutorData} data
    */
    DropTargetsService.prototype.doFirstOpenTimeslotDropTargets = function (data) {
        if (this.gridCollections) {
            this.gridCollections.forEach(function (gridCollection) {
                if (gridCollection.meta.resource['isDropZone'] === undefined || (gridCollection.meta.resource['isDropZone'] !== undefined && gridCollection.meta.resource['isDropZone'] === true)) {
                    gridCollection.children.forEach(function (gridSegment) {
                        var found = false;
                        gridSegment.children.forEach(function (gridRow) {
                            if (!found) {
                                gridRow.children.forEach(function (gridColumn) {
                                    if (!found && gridColumn.gridWorkPatterns.length > 0) {
                                        var sumDuration_1 = 0;
                                        gridColumn.gridWorkPatterns.forEach(function (workpattern) {
                                            sumDuration_1 += workpattern['timeSpan'];
                                        });
                                        var sumEffort_1 = moment.duration('PT0S');
                                        gridColumn.gridAssignments.forEach(function (item) {
                                            sumEffort_1.add(item['entity']['Effort']);
                                        });
                                        gridColumn.gridAppointments.forEach(function (item) {
                                            sumEffort_1.add(item['entity']['Effort']);
                                        });
                                        gridColumn.gridAbsences.forEach(function (item) {
                                            sumEffort_1.add(item['entity']['Effort']);
                                        });
                                        if (sumEffort_1 < moment.duration(sumDuration_1, 'milliseconds')) {
                                            gridColumn.meta.isDropZone = true;
                                            found = true;
                                        }
                                        else {
                                            gridColumn.meta.isDropZone = false;
                                        }
                                    }
                                    else {
                                        gridColumn.meta.isDropZone = false;
                                    }
                                });
                            }
                            else {
                                gridRow.children.forEach(function (gridColumn) {
                                    gridColumn.meta.isDropZone = false;
                                });
                            }
                        });
                    });
                }
            });
        }
        this.dropTargetsChanged.emit(true);
    };
    /**
     * Get drop targets overlaps first dropitem
     * @param {ExecutorData} data
     */
    DropTargetsService.prototype.doTimeslotDropTargets = function (data) {
        var itemStart = moment(data.items[0]['Start']);
        var itemFinish = moment(data.items[0]['Finish']);
        if (this.gridCollections) {
            this.gridCollections.forEach(function (gridCollection) {
                if (gridCollection.meta.resource['isDropZone'] === undefined || (gridCollection.meta.resource['isDropZone'] !== undefined && gridCollection.meta.resource['isDropZone'] === true)) {
                    gridCollection.children.forEach(function (gridSegment) {
                        gridSegment.children.forEach(function (gridRow) {
                            gridRow.children.forEach(function (gridColumn) {
                                /*
                                    https://github.com/Symagic/html5/issues/2629#issuecomment-498609969
                                    De regel "Een timeslot zonder werkpatronen zal nooit worden geadviseerd"
                                    blijkt alleen van toepassing te zijn op assignments.
                                    De bugissue was dus onterecht. Sorry daarvoor.
                                    ...De oude situatie herstellen.
                                */
                                // Oude code:
                                gridColumn.meta.isDropZone = gridColumn.meta.start.isSameOrBefore(itemFinish, 'minutes') && gridColumn.meta.finish.isSameOrAfter(itemStart, 'minutes');
                                // Nieuwe code, mocht men toch meer willen.
                                // gridColumn.meta.isDropZone = false;
                                // if (!(gridColumn.meta.start.isSameOrBefore(itemFinish, 'minutes') && gridColumn.meta.finish.isSameOrAfter(itemStart, 'minutes'))) {
                                //     return;
                                // }
                                // const working = gridColumn.gridWorkPatterns.find(it => {
                                //     const start = <moment.Moment>it['start'];
                                //     const finish = <moment.Moment>it['finish'];
                                //     return start.isSameOrBefore(itemStart, 'minutes') && finish.isSameOrAfter(itemFinish, 'minutes');
                                // })
                                // if (working == null) {
                                //     return;
                                // }
                                // const absence = gridColumn.gridAbsences.find(it => {
                                //     const start = <moment.Moment>it['start'];
                                //     const finish = <moment.Moment>it['finish'];
                                //     return start.isSameOrBefore(itemStart, 'minutes') && finish.isSameOrAfter(itemFinish, 'minutes');
                                // })
                                // if (absence != null) {
                                //     return;
                                // }
                                // const anotherShift = gridColumn.gridAttendants.find(it => {
                                //     const start = <moment.Moment>it['start'];
                                //     const finish = <moment.Moment>it['finish'];
                                //     return start.isSameOrBefore(itemStart, 'minutes') && finish.isSameOrAfter(itemFinish, 'minutes');
                                // })
                                // if (anotherShift != null) {
                                //     return;
                                // }
                                // gridColumn.meta.isDropZone = true;
                            });
                        });
                    });
                }
            });
        }
        this.dropTargetsChanged.emit(true);
    };
    return DropTargetsService;
}(AbstractBase));
export { DropTargetsService };
